// vk-deploy: bundle-gallery-swipe-guard-2026-08-11-r2
(() => {
  const GALLERY_SELECTOR = '[data-vk-card-gallery]';
  const touchStates = new WeakMap();
  const suppressClicksUntil = new WeakMap();

  const getSlides = (gallery) => Array.from(gallery.querySelectorAll('[data-vk-card-slide]'));

  const getIndex = (gallery) => {
    const slides = getSlides(gallery);
    const datasetIndex = Number.parseInt(gallery.dataset.vkCardIndex, 10);
    if (Number.isInteger(datasetIndex) && datasetIndex >= 0 && datasetIndex < slides.length) return datasetIndex;
    return Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
  };

  const setSlide = (gallery, requestedIndex, announce = true) => {
    const slides = getSlides(gallery);
    if (slides.length < 2) return;

    const nextIndex = ((requestedIndex % slides.length) + slides.length) % slides.length;
    const dots = gallery.querySelectorAll('[data-vk-card-dot]');

    slides.forEach((slide, slideIndex) => {
      const active = slideIndex === nextIndex;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    });

    dots.forEach((dot, dotIndex) => {
      const active = dotIndex === nextIndex;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    gallery.dataset.vkCardIndex = String(nextIndex);

    if (announce) {
      const status = gallery.querySelector('[data-vk-card-status]');
      if (status) {
        const slideLabel = gallery.dataset.vkCardSlideLabel || 'Slide';
        const ofLabel = gallery.dataset.vkCardOfLabel || 'of';
        status.textContent = `${slideLabel} ${nextIndex + 1} ${ofLabel} ${slides.length}`;
      }
    }
  };

  const getChangedTouch = (event, identifier) =>
    Array.from(event.changedTouches).find((touch) => touch.identifier === identifier);

  document.addEventListener('click', (event) => {
    const gallery = event.target.closest(GALLERY_SELECTOR);

    if (
      gallery &&
      event.target.closest('.lv-card-media-link') &&
      Date.now() < (suppressClicksUntil.get(gallery) || 0)
    ) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    const control = event.target.closest('[data-vk-card-prev], [data-vk-card-next], [data-vk-card-dot]');
    if (control) {
      const controlGallery = control.closest(GALLERY_SELECTOR);
      if (!controlGallery) return;

      event.preventDefault();
      event.stopPropagation();

      if (control.hasAttribute('data-vk-card-dot')) {
        setSlide(controlGallery, Number.parseInt(control.dataset.vkCardDot, 10));
      } else {
        setSlide(controlGallery, getIndex(controlGallery) + (control.hasAttribute('data-vk-card-next') ? 1 : -1));
      }
      return;
    }

    const variantThumbnail = event.target.closest('[data-lv-variant-thumb]');
    if (!variantThumbnail) return;

    const variantGallery = variantThumbnail.closest('.product-card-wrapper')?.querySelector(GALLERY_SELECTOR);
    if (variantGallery) window.requestAnimationFrame(() => setSlide(variantGallery, 0, false));
  });

  document.addEventListener(
    'touchstart',
    (event) => {
      if (event.touches.length !== 1) return;

      const gallery = event.target.closest(GALLERY_SELECTOR);
      if (
        !gallery ||
        event.target.closest(
          '[data-vk-card-prev], [data-vk-card-next], [data-vk-card-dot], .lv-card-quick-add, input, select, textarea'
        )
      ) {
        return;
      }

      const touch = event.touches[0];
      touchStates.set(gallery, {
        identifier: touch.identifier,
        startX: touch.clientX,
        startY: touch.clientY,
        currentX: touch.clientX,
        currentY: touch.clientY,
      });
    },
    { passive: true }
  );

  document.addEventListener(
    'touchmove',
    (event) => {
      const gallery = event.target.closest(GALLERY_SELECTOR);
      const state = gallery ? touchStates.get(gallery) : null;
      if (!state) return;

      const touch = Array.from(event.touches).find((item) => item.identifier === state.identifier);
      if (!touch) return;
      state.currentX = touch.clientX;
      state.currentY = touch.clientY;
    },
    { passive: true }
  );

  document.addEventListener(
    'touchend',
    (event) => {
      const gallery = event.target.closest(GALLERY_SELECTOR);
      const state = gallery ? touchStates.get(gallery) : null;
      if (!state) return;

      const touch = getChangedTouch(event, state.identifier);
      touchStates.delete(gallery);
      if (!touch) return;

      const deltaX = touch.clientX - state.startX;
      const deltaY = touch.clientY - state.startY;
      const isHorizontalSwipe = Math.abs(deltaX) >= 36 && Math.abs(deltaX) > Math.abs(deltaY) * 1.25;
      if (!isHorizontalSwipe) return;

      event.preventDefault();
      suppressClicksUntil.set(gallery, Date.now() + 500);
      gallery.dataset.vkCardSuppressClicksUntil = String(Date.now() + 500);
      setSlide(gallery, getIndex(gallery) + (deltaX < 0 ? 1 : -1));
    },
    { passive: false }
  );

  document.addEventListener(
    'touchcancel',
    (event) => {
      const gallery = event.target.closest(GALLERY_SELECTOR);
      if (gallery) touchStates.delete(gallery);
    },
    { passive: true }
  );

  document.querySelectorAll(GALLERY_SELECTOR).forEach((gallery) => setSlide(gallery, getIndex(gallery), false));
})();
